import {Link, AppBar, Drawer, IconButton, List, ListItem, ListItemIcon, makeStyles, Toolbar } from '@material-ui/core'
import { animateScroll as scroll} from 'react-scroll'
import { CancelOutlined, Menu } from '@material-ui/icons'
import React, { useState } from 'react';

const links =[
    {
        link: 'https://www.linkedin.com/in/evagonzalezbosch/',
        icon: <i class="fab fa-linkedin"  fontSize='medium'></i>
    },  
    {
        link: 'https://github.com/Glezarts',
        icon: <i class="fab fa-github-square" fontSize='medium'></i>
    },
    {
        link: 'https://www.behance.net/glezart',
        icon: <i class="fab fa-behance-square" fontSize='medium'></i>
    },
    {
        link: 'mailto:evaglezart.com',
        icon:<i class="fas fa-envelope" fontSize="medium" ></i>
    }
]

const Navbar = () => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
 
    return (
        <AppBar position="sticky" className={classes.root}>
            <Toolbar className={classes.toolbar }>
                <List className={classes.menu}>
                    {
                        
                        links.map(({link, icon}, index)=>(
                            <Link key={index} href={link} target='_blank' spy={true} className={classes.icon}>{icon}</Link>
                        ))
                    }
                </List>
                <IconButton edge= "end" className={classes.menubutton} onClick= {()=> setOpen(!open)}>
                <Menu/>
                </IconButton>

            </Toolbar>
            <Drawer anchor="right" open={open} onClose={()=> setOpen(false)} >
            <IconButton className={classes.sidebar} onClick= {()=> setOpen(false)}>
                <CancelOutlined fontSize="large" className={classes.cancelicon}/>
            </IconButton>
            {
                        links.map(({id, text, icon}, index)=>(
                            <Link key={index} to={id } spy={true} activeClass="active" smooth={true} duration={500} offset={-55}>
                                <ListItem component= "h5">
                                <span>
                                    <ListItemIcon >
                                        {icon}
                                    </ListItemIcon>
                                    </span>
                                    {text}
                                </ListItem>
                                </Link>
                        ))
                    }
        </Drawer>
        </AppBar>
        
        
    )

}

const useStyles = makeStyles((theme) => ({
    root: {
        background: "transparent",
        top:0,
        left:0,
        right:0,
        zIndex:999,
        position:'absolute',
        boxShadow:'none'
    },
    toolbar:{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    },
    menu:{
        display:'flex',
        alignItems: "center",
        [theme.breakpoints.down("sm")]:{
            display: "none",
        },
        "& a": {
            color: "white",
            marginLeft: theme.spacing(4),
            fontSize: "1.4rem",
            transition: "0.3s",
            padding: "0px 30px 5px 30px",
            textAlign: "center"

        },
        "& a:hover":{
            cursor: "pointer",
            color: "#654154",
            borderBottom:'2px solid #654154'
        },
        '&.active':{
            color:'#654154'
        }
        
    },
    menubutton:{
        display: "none",
        [theme.breakpoints.down('sm')]:{
            display: "block",
            color: "#fff",
            position: "absolute",
            top:0,
            right: 10,
        }
    },
    cancelicon:{
        color: "#DD965D",
        position: "absolute",
        top: 0,
        right: 10,

    },
    sidebar: {
        width:"40vw",
        [theme.breakpoints.down('sm')]:{
            width:'60vw',
            marginTop:10
        },
        "& h5": {
            margin: theme.spacing(20, 0, 0, 4),
            fontSize: "1.4rem",
            fontWeight: "bold"
        },
        "& h5:hover":{
            cursor: "pointer",
            color: "#DD965D",
        }
    }
}))

export default Navbar
